import { useEffect, useState } from 'react';

/** Pause is available independently of the operating system's motion preference. */
export function MotionToggle() {
  const [paused, setPaused] = useState(false);
  useEffect(() => {
    document.documentElement.dataset.motion = paused ? 'paused' : 'playing';
    window.dispatchEvent(new Event('geefamily:motion'));
    return () => {
      delete document.documentElement.dataset.motion;
    };
  }, [paused]);

  return (
    <button
      type="button"
      className="motion-toggle"
      onClick={() => setPaused((value) => !value)}
      aria-label={paused ? 'Animasyonları oynat' : 'Animasyonları durdur'}
      aria-pressed={paused}
      title={paused ? 'Animasyonları oynat' : 'Animasyonları durdur'}
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 20 20"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
      >
        {paused ? (
          <path d="m7 4 9 6-9 6V4Z" />
        ) : (
          <>
            <path d="M7 4v12M13 4v12" />
            <circle cx="10" cy="10" r="8.5" strokeOpacity=".35" />
          </>
        )}
      </svg>
    </button>
  );
}
